__turbopack_context__.v({
  "emptyCatalog": "catalog-empty-module-scss-module__ahqSGa__emptyCatalog",
});
